













import AfterFetchComponent from "@/components/base/AfterFetchComponent";
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {ManagingCompanies} from "@/models/ManagingCompanies";
import {ExportType} from '@payroll/grid-widget/src/models/ExportType'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {BaseRequest} from '@payroll/optimus-common'
import {Component, Prop} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";

@Component
export default class AccountDetailsTab extends AfterFetchComponent {

  @Action('getAccountDetails', StoreNamespace.CUSTOMER_SERVICE) getAccountDetails: any
  @Action('exportAccountDetails', StoreNamespace.CUSTOMER_SERVICE) exportAccountDetails: any

  @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string

  @Prop() memberIdNum!: string
  @Prop() memberName!: string

  private columns: GridColumn[] = []

  beforeMount() {
    this.hasFeedback = true
  }

  mounted() {
    this.getAccountDetails({
      pathVariable: this.memberIdNum,
      requestorCallback: this
    })
  }

  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    if (requestName === 'findMembersOrEmployersFor/getAccountDetails') {
      this.columns = data.columns

      this.columns.forEach((column: GridColumn) => {
        column.hideSorting = true

        if (this.mngCompanyName.includes(ManagingCompanies.GILAD.toLowerCase())) {
          if (column.property == "totalCompensations") {
            column.header = 'compensationRedemptionValues'
          }

          if (column.property === "accountNum") {
            column.header = 'program_number'
          }
        }
      })

      this.$emit('successResults', data)
    } else {
      this.$emit('successExport', data)
    }
  }

  onLoadMore(pageNumber: number, pageSize: number) {
    this.getAccountDetails({
      pathVariable: this.memberIdNum,
      requestorCallback: this,
      requestBody: {
        pageNumber: pageNumber,
        pageSize: 3
      }
    })
  }

  exportAccountDetailsGrid(exportType: ExportType, gridColumns: Array<GridColumn>): void {
    let columnWidths: Map<string, number> = new Map([
      ['fundName', 220],
      ['fundStatus', 60],
      ['accountNum', 85],
      ['memberBalance', 75],
      ['employerBalance', 75],
      ['compensationsBalance', 75],
      ['accountBalance', 75],
      ['dataDate', 70]])

    gridColumns = gridColumns.map((column: GridColumn) => {
      return {
        property: column.property,
        header: column.header,
        widthInPoints: columnWidths.get(column.property) || 100
      } as GridColumn
    })

    this.exportAccountDetails({
      requestBody: {
        headerText: this.exportFileName,
        exportType: exportType,
        columnsList: gridColumns
      } as BaseRequest,
      pathVariable: this.memberIdNum,
      requestorCallback: this
    });
  }

  get exportFileName(): string {
    return '' + this.$t('account_details_for_employee', {
      employeeIdNum: this.memberIdNum,
      employeeName: this.memberName.replace(/["]+/g, "''")
    })
  }

  get isExportAble(): boolean {
    return !this.mngCompanyName.includes(ManagingCompanies.GILAD.toLowerCase());
  }
}
